'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _CookieBanner = require('./CookieBanner');

var _CookieBanner2 = _interopRequireDefault(_CookieBanner);

exports['default'] = _CookieBanner2['default'];

var _browserCookieLite = require('browser-cookie-lite');

exports.cookie = _browserCookieLite.cookie;

var _BannerContent2 = require('./BannerContent');

var _BannerContent3 = _interopRequireDefault(_BannerContent2);

exports.BannerContent = _BannerContent3['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-cookie-banner/lib/index.js
// module id = 601
// module chunks = 114276838955818